export default __webpack_public_path__ + "static/media/journey2.ba8b98bf.mp4";